import {
  useAppSelector,
  mapSelector,
  isEditingSelector,
} from '../../../../store';

import { GroupedByCategoryList } from './GroupedByCategoryList';
import { GroupedByLayerList } from './GroupedByLayerList';

export function GroupedSpacesList() {
  const iMap = useAppSelector(mapSelector);
  const isEditing = useAppSelector(isEditingSelector);

  return iMap.groupBy === 'categories' || isEditing
        ? <GroupedByCategoryList />
        : <GroupedByLayerList />
    ;
}

